// https://companywelfaresvil.poste.it/shopping/api/v1/orders/1204462b-fd00-48bf-aaf0-8fcbbff08583
import { refundCollection } from 'app/src/msw/refund/initialSeed/refund'
import { refundsOrdersCollection } from 'app/src/msw/shopping/initialSeed/orders'
import type { refundApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './refund/api/v1'

export const deleteRefund = http.delete<refundApi.RefundRequestDeletePathParams, object, undefined>(
  apiBaseUrl + '/refunds/:refundId',
  async ({ params }) => {
    console.log('########## MSW: START DELETE REFUND ##########')

    await new Promise((resolve) => setTimeout(resolve, 3000))
    /* Preparing datas for refund */
    const refund = refundCollection.findFirst((q) => q.where({ refundId: params.refundId }))
    console.log('STEP 1 => check refund: ', refund ? 'OK' : 'KO')
    const refundOrder = refundsOrdersCollection.findFirst((q) => q.where({ orderId: refund?.attributes?.orderId }))
    console.log('STEP 2 => check refund order: ', refundOrder ? 'OK' : 'KO')

    if (refundOrder && refund) {
      /* update order status */
      await refundsOrdersCollection.update(refundOrder, {
        data(order) {
          order.status = 'canceled'
        },
      })
      /* update refund status */
      // await refundCollection.update((q) => q.where({ refundId: params?.refundId as string }), {
      //   data(refund) {
      //     refund.status.value = 'CANCELED'
      //     refund.status.updatedAt = new Date().toISOString()
      //     refund.isCancelable = false
      //   },
      // })
      await refundCollection.delete((q) => q.where({ refundId: params?.refundId as string }))
    } else {
      console.error('Error processing refund deletion: missing data')
      console.log('########## MSW: END DELETE REFUND ##########')
      return HttpResponse.text(undefined, { status: 400 })
    }

    console.log('########## MSW: END DELETE REFUND ##########')
    return HttpResponse.text(undefined, { status: 204 })
  },
)
